export default __webpack_public_path__ + "static/media/floor3.8614597d.svg";